import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import AIAssistant from '../components/AIAssistant';

export default function AIAssistantPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="bg-white border-b border-slate-200 px-4 py-3 flex items-center gap-3">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1 text-sm text-slate-600 hover:text-slate-900"
          data-testid="ai-page-back"
        >
          <ArrowLeft size={16} /> Back
        </button>
        <h1 className="text-base font-semibold text-slate-900">AI Admin Copilot</h1>
        <div className="ml-auto text-xs text-slate-500">
          <Link to="/admin" className="hover:text-indigo-600">
            ← Admin Panel
          </Link>
        </div>
      </header>
      <div className="flex-1 min-h-0 max-w-6xl w-full mx-auto bg-white border border-slate-200 my-4 rounded-2xl overflow-hidden">
        <AIAssistant compact={false} showSidebar />
      </div>
    </div>
  );
}
